const TechnicienCard = ({ data }) => {
  return (
    <div className="stat-card">
      <h3>{data.technicien_nom}</h3>
      <p>Total RDV : <strong>{data.total_rdv}</strong></p>
      <p>✅ Terminés : <strong>{data.termine}</strong></p>
      <p>🔄 En cours : <strong>{data.en_cours}</strong></p>
      <p>⏳ En attente : <strong>{data.en_attente}</strong></p>
      <p>⏱️ Heures travaillées : <strong>{Number(data.total_heures).toFixed(2)} h</strong></p>
    </div>
  );
};


export default TechnicienCard;
